import { makeStyles } from "tss-react/mui"
import { animations } from "../../../assets/animations"
import { spacing } from "../../../assets/spacing"

export const useStyles = makeStyles()((theme) => ({
    ...animations(theme),
    ...spacing(theme),

    icon: {
        opacity: 0.7,
        animationDelay: "0.62s",
        transition: "0.18s all ease-in-out",

        "&:hover": {
            opacity: 0.9,
        },
    },
}))
